//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';
import template from './universal-image-actions-tributary-add-ons.html';

class UniversalImageActionsTributaryAddOns {
  public isCustomStringsEnabled: boolean;
  constructor(
        private SessionVarsService,
    ) { }

  public $onInit() {
    this.isCustomStringsEnabled = this.SessionVarsService.isFeatureEnabled('like2buy_customizations');
  }
}

angular.module('uia').component('universalImageActionsTributaryAddOns', {
  template,
  controller: [
    'SessionVarsService',
    UniversalImageActionsTributaryAddOns,
  ],
});
